<template>
  <div class="tab" :style="styleObj">
    <div class="title">{{title}}</div>
    <div class="cash">{{cash}}</div>
      <div class="compare g-flex-center-start">
        <span v-if="tabType === 1">较上一日</span>
        <span v-if="tabType === 2">较上7日</span>
        <span v-if="tabType === 3">较上30天</span>
        <img :src="num < 0 ? down : up" alt=""><span>{{(Math.abs(num || 0) * 100).toFixed(2)}}%</span>
      </div>
  </div>
</template>
<script>
export default {
  props:{
    title: {
      type: String
    },
    cash: {
      type: Number
    },
    styleObj: {
      type: Object
    },
    tabType: {
      type: Number
    },
    num: {
      type: Number
    }
  },
  data () {
    return {
      down: 'https://web.nlktj.com/ty/czb-merchant-web/images/customer/down.png',
      up: 'https://web.nlktj.com/ty/czb-merchant-web/images/customer/up.png'
    }
  }
}
</script>
<style lang="less" scoped>
.tab{
  padding: 20px;
  background: #fff;
}
.title{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.cash{
  margin: 5px 0 5px 0;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
}
.compare{
  padding: 10px 0 5px 0;
  >span:nth-child(1){
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  >span:nth-child(3){
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
  }
  img{
    margin-left: 5px;
    display: block;
    width: 8px;
    height: 14px
  }
}
</style>